module.exports = __webpack_public_path__ + "img/05.5607d268.png";